"use strict";

require("core-js/modules/es.object.from-entries.js");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleProps = void 0;

function styleProps(_a) {
  var children = _a.children,
      className = _a.className,
      style = _a.style,
      dangerouslySetInnerHTML = _a.dangerouslySetInnerHTML,
      other = __rest(_a, ["children", "className", "style", "dangerouslySetInnerHTML"]);

  var dataAttributes = Object.fromEntries(Object.entries(other).filter(function (_a) {
    var _b = __read(_a, 1),
        key = _b[0];

    return key.startsWith('data-');
  }));
  return __assign({
    children: children,
    className: className,
    style: style,
    dangerouslySetInnerHTML: dangerouslySetInnerHTML
  }, dataAttributes);
}

exports.styleProps = styleProps;